class OverviewHandler {
  private isOpen: boolean = false;
  private toggleButton: HTMLElement | null = null;
  private body: HTMLElement | null = null;
  private overviewContainer: HTMLElement | null = null;

  constructor() {
    this.body = document.body;
    this.init();
  }

  private init(): void {
    // Find the overview toggle button and container
    this.toggleButton = document.querySelector(".overview-toggle");
    this.overviewContainer = document.querySelector(".overview");

    if (this.toggleButton) {
      this.toggleButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggle();
      });
    }

    // Close overview when clicking on a link inside it
    const overviewLinks = document.querySelectorAll(
      ".overview a:not(.overview-toggle)"
    );
    overviewLinks.forEach((link) => {
      link.addEventListener("click", () => {
        this.close();
      });
    });

    // Close overview when clicking outside of it
    document.addEventListener("click", (e) => {
      if (!this.isOpen) return;

      const target = e.target as HTMLElement;
      const isInsideOverview = this.overviewContainer?.contains(target);
      const isToggleButton = this.toggleButton?.contains(target);

      if (!isInsideOverview && !isToggleButton) {
        this.close();
      }
    });

    // Optional: Close overview on escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen) {
        this.close();
      }
    });
  }

  /**
   * Toggle overview open/closed
   */
  public toggle(): void {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  /**
   * Open the overview
   */
  public open(): void {
    if (!this.body || this.isOpen) return;

    this.body.classList.add("show-overview");
    this.isOpen = true;

    if (this.toggleButton) {
      this.toggleButton.setAttribute("aria-expanded", "true");
    }

    console.log("Overview opened");
  }

  /**
   * Close the overview
   */
  public close(): void {
    if (!this.body || !this.isOpen) return;

    this.body.classList.remove("show-overview");
    this.isOpen = false;

    if (this.toggleButton) {
      this.toggleButton.setAttribute("aria-expanded", "false");
    }

    console.log("Overview closed");
  }

  /**
   * Check if overview is currently open
   */
  public getIsOpen(): boolean {
    return this.isOpen;
  }
}

export default OverviewHandler;
